import { createAsyncSelectors } from '@lib/selectors';
import { useAction } from '../useAction';
import { useSonarSelector } from '../useSonarSelector';
import { coreActions, PostInitiativeTaskLinkRequest } from '@sonar-software/sonar-core';

export interface UseLinkInitiativeTaskResult {
	isProcessing: boolean;
	isSuccessful: boolean;
	request: (data: PostInitiativeTaskLinkRequest) => void;
}

const selectors = createAsyncSelectors((state) => state.core.initiatives.tasks.link.post);

export function useLinkInitiativeTask(): UseLinkInitiativeTaskResult {
	const request = useAction(coreActions.requestPostCoreInitiativesTasksLink);

	const isProcessing = useSonarSelector(selectors.isRequested);
	const isSuccessful = useSonarSelector(selectors.isReceived);

	return {
		isProcessing,
		isSuccessful,
		request
	};
}

useLinkInitiativeTask.selectors = selectors;
